<app-header-page>
    <h1>{{ 'HEADERS.PROJECT' | translate }}</h1>
</app-header-page>

<div *ngIf="currentProject">
    <div class="flex-display">
        <div class="px-4 py-2 project-icon">
            <i [class]=" currentProject.type === 'organization' ? 'bi bi-buildings' : 'bi bi-person-square'"></i>
        </div>
        <div class="p-3 project-body">
            <h2>
                {{ 'PROJECT.TITLE' | translate }}:
                <app-component-input-inline
                        (emitSave)="currentProject.name = $event"
                        [editByPen]="true"
                        [value]="currentProject.name"
                ></app-component-input-inline>
            </h2>
            <strong>{{ 'PROJECT.DOMAIN' | translate }}: </strong> <span>{{ currentProject.domain }}</span><br>
            <span>
                <strong>{{ 'PROJECT.TYPE.TYPE' | translate }}
                    : </strong>{{ 'PROJECT.TYPE.' + currentProject.type | translate }}
                <i (click)="currentProject.type = currentProject.type === 'person' ? 'organization' : 'person'"
                   [ngbTooltip]="(currentProject.type === 'person' ? 'PROJECT.TYPE_TOOLTIP.ORGANIZATION' : 'PROJECT.TYPE_TOOLTIP.PERSON') | translate"
                   class="bi bi-arrow-repeat active-icon"></i>
            </span>

            <div class="flex-display">
                <span>
                    <strong>{{ 'PROJECT.SUBTYPE.SUBTYPE' | translate }}: </strong>
                    <span *ngIf="!editProject">{{ currentProject.subtype ? ('PROJECT.SUBTYPE.' + currentProject.subtype | translate) : ' -' }}</span>
                    <i (click)="editProject = true" *ngIf="!editProject" class="bi bi-pen active-icon"></i>
                </span>

                <select #projectSubType
                        (change)="currentProject.subtype = projectSubType.value"
                        *ngIf="editProject"
                        class="select-subtype form-select"
                >
                    <option [selected]="!currentMember.project_setting.project.subtype"
                            [value]="">{{ 'PROJECT.SUBTYPE.EMPTY' | translate }}
                    </option>
                    <option [selected]="currentMember.project_setting.project.subtype === 'ooo'"
                            [value]="'ooo'">{{ 'PROJECT.SUBTYPE.ooo' | translate }}
                    </option>
                    <option [selected]="currentMember.project_setting.project.subtype === 'ip'"
                            [value]="'ip'">{{ 'PROJECT.SUBTYPE.ip' | translate }}
                    </option>
                    <option [selected]="currentMember.project_setting.project.subtype === 'zao'"
                            [value]="'zao'">{{ 'PROJECT.SUBTYPE.zao' | translate }}
                    </option>
                    <option [selected]="currentMember.project_setting.project.subtype === 'ao'"
                            [value]="'ao'">{{ 'PROJECT.SUBTYPE.ao' | translate }}
                    </option>
                </select>
            </div>

            <button (click)="updateProject()" class="btn btn-success mt-3">
                <span>{{ 'BUTTON_TEXT.ONLY_SAVE' | translate }}</span>
            </button>
        </div>
    </div>
</div>
